import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import Header from './components/Header';
import Manifesto from './components/Manifesto';
import Collection from './components/Collection';
import Arrangements from './components/Arrangements';
import Studio from './components/Studio';
import Footer from './components/Footer';
import KindWords from './components/KindWords';
import Enquiry from './components/Enquiry';
import { scrollToEl } from '@/lib/smoothScroll';

export default function Home() {
  const { hash, key } = useLocation();

  // Hash links (/#studio, /#collection) — wait for ScrollTrigger pin spacing before scrolling
  useEffect(() => {
    if (!hash) return undefined;
    const t = window.setTimeout(() => {
      ScrollTrigger.refresh();
      const el = document.getElementById(hash.slice(1));
      if (el) scrollToEl(el);
    }, 120);
    return () => window.clearTimeout(t);
  }, [hash, key]);

  return (
    <main className="ff-sans min-h-screen bg-white [overflow-x:clip] text-[#111111]">
      <Header />
      <Manifesto />
      <Collection />
      <Arrangements />
      <Studio />
      <KindWords />
      <Enquiry />
      <Footer />
    </main>
  );
}